import { z } from 'zod';
// Font token registry (§9). A type-style binds to a font token; the renderer
// resolves the token to a Google Fonts (or self-hosted) family and is
// responsible for preloading via delayRender/continueRender (§14).
// `allura` is the cursive script face used by the v1 caption-tease caption
// line; exposing it as a token lets any template pick it per-element via a
// styleOverride.fontRef without baking a face into a type-style role.
// `jost` is a Futura revival, and is the face reel-4's list, close and outro
// letterforms actually measure as — circular O, monoline, straight-legged R.
// Its 100-900 range is why it was chosen over the closer-looking Optima-class
// candidates (Julius Sans One, Marcellus, Tenor Sans, Questrial): every one of
// those ships a SINGLE weight, so none can express a light/bold relationship
// within a line, which the same reel needs in three places.
// `playfair-light` is the NEWER sibling family (Google's "Playfair", not
// "Playfair Display"). Near-identical letterforms, but its cuts start at 300
// where Playfair Display floors at 400 — the only way to set this face lighter
// than regular. Bind it per-element via styleOverride.fontRef.
export const FONT_TOKENS = [
    'inter',
    'playfair',
    'playfair-light',
    'cormorant',
    'jost',
    'allura',
];
export const fontRef = z.enum(FONT_TOKENS);
//# sourceMappingURL=font-tokens.js.map